import {fetchWithState, getFetchedJSON} from '~/misc/fetch';
import {ActionError} from '~/misc/dispatch';
import toLegacyLoad from '~/misc/toLegacyLoad';


const getLoad = (getState, id) =>
  fetchWithState(getState, {
    url: `/tl/shipments/${id}/share`,
    method: 'GET',
  })
    .then(getFetchedJSON)
    .then(item => toLegacyLoad(item, item.created_at || (new Date() - item.age)))
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        return error.responsePromise.then(err => {
          throw new ActionError(err.message);
        })
      }
      throw error;
    });

export default getLoad;


// WEBPACK FOOTER //
// ./src/api/getLoad.js